import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { Qualification } from '../../../mdqx-graphql-types';

export class QualificationEntity implements SelectSearchOption<QualificationEntity> {
    constructor(public Id: number, public Name: string) {}
    get optionLabel() {
        return this.Name;
    }
    static readonly GqlFields: Array<keyof Qualification> = ['id', 'name'];
    static fromBackend(res: Qualification) {
        return new QualificationEntity(res.id, res.name);
    }
}
